import ApiService from './ApiService.js';

var PrintService = {
    download: function($headers,$data,$designView,$type,$docName)
    {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="downloadDocument"
            $options.method="post"
            $options.responseType='blob'
            $options.data= {
                headers:$headers, 
                data:$data,
                type:$type,
                designView:$designView,
                documentName:$docName
            }
           // alert($docName)
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    

};
export default PrintService;
